import AnalyticsJI from './AnalyticsJI.js';
import Discord from './discord.js';
import Config from './config.js';
export default class App {
    constructor() {
        //public
        this.game = null;
        this.appName = "Minesweeper.io";
        this.version = "1.4.0";
        this.serverUrl = "wss://minesjd.com";
        this.serverUrls = { "USA": "wss://minesjd.com", "EU": "wss://eu.minesjd.com" };

        var size = 64;
        // this.minesweeper = new MinesweeperProxy(null, size, size, size * size / 7);
        this.minesweeper = new Minesweeper(null, size, size, size * size / 7);
        this.minesweeper.init();
        this.user = null;
        this.adPlayer = null;

        this.discord = new Discord();
        this.isOnDiscord = false;
        this.leaderboardLength = 10;

    }


    async init() {
        this.showPage("loading");

        // //delay 5 seconds
        // await new Promise(resolve => setTimeout(resolve, 3000));

        window.addEventListener("hashchange", (e) => { this.hashchange() });

        this.isOnDiscord = this.discord.isOnDiscord();



        //read config
        if (Config && Config.appName) this.appName = Config.appName;
        if (Config && Config.version) this.version = Config.version;
        if (Config && Config.leaderboardLength) this.leaderboardLength = Config.leaderboardLength;
        if (Config && Config.serverUrl_Default) this.serverUrl = Config.serverUrl_Default;
        if (Config && Config.serverUrls) this.serverUrls = Config.serverUrls;
        this.showWebContent = Config?.showWebContent ?? false;

        //if is hosted on https://minesjd.com or https://eu.minesjd.com then show web content
        if (this.showWebContent === null) {
            const hostname = window.location.hostname;
            if (hostname === "minesjd.com" || hostname === "eu.minesjd.com") {
                this.showWebContent = true;
            }
        }

        if (typeof FBInstantGame !== "undefined") FBInstantGame.onLoaded(_this);

        this.analyticsJI = new AnalyticsJI(this.appName, this.version);
        this.analyticsJI.TrackStart();

        //load user data for localstorage
        this.user = Storage.load('user') || new User();

        //todo: load data from server



        //listen to game events
        this.minesweeper.onMessage2 = this.onMessage.bind(this);

        Achievement.onNewAchievement = this.showAchievementPopup.bind(this);

        //if (typeof Adinplay !== 'undefined')
        //    this.adPlayer = new Adinplay();

        let allowAds = true;

        //set server url 
        if (this.user.serverUrl) {
            //only set server url if it's in the list of server urls
            if (this.serverUrls) {
                if (Object.values(this.serverUrls).includes(this.user.serverUrl)) {
                    this.serverUrl = this.user.serverUrl;
                } else {
                    this.user.serverUrl = null; // clear the user.serverUrl if it's not valid
                }
            }
        }


        // Check if on Discord 
        if (this.isOnDiscord) {
            allowAds = false;
            this.showWebContent = false;
            if (Config && Config.serverUrl_Discord) this.serverUrl = Config.serverUrl_Discord;

            //hide server url selector if on discord  - has to use discord proxy server 
            const serverDropdown = document.getElementById('serverDropdown');
            if (serverDropdown && this.isOnDiscord) {
                serverDropdown.style.display = "none";
            }

            try {
                //get name and avatar
                let data = await this.discord.getData();

                if (data.name) this.user.name = data.name;
                if (data.avatar && !this.user.avatar) this.user.avatar = data.avatar;
                if (data.avatar) this.user.avatar_discord = data.avatar;
                if (data.guildId) this.user.roomId = data.guildId;

                //set server url - it has to be the same as the discord server

                this.refreshPage();
            } catch (e) {
                console.error(e);
            }
        }



        if (this.showWebContent === false) {
            //hide web content
            const webcontent = document.getElementById("webcontent");
            if (webcontent) webcontent.style.display = "none";
        }

        if (allowAds && typeof AdvertismentGD !== 'undefined') {
            //this.adPlayer = new AdvertismentGD();
            //this.adPlayer.init();
        }


        // this.adPlayer.init();





        this.createGameUI();
        // this.hashchange();


        //check for facebook auto login
        this.checkForFacebookAutoLogin();
        //show main menu
        this.showPage("menu");

        // this.hashchange();


        //wire up all the onclick events. Discord does not allow inline javascript

        document.body.oncontextmenu = function () { return false; }

        if (document.getElementById('btnStartGame')) document.getElementById('btnStartGame').onclick = function () {
            location.hash = "#/game";
        }

        if (document.getElementById('txtUserName')) document.getElementById('txtUserName').onchange = function () { appController.updateName(this); }
        if (document.getElementById('profilePage_txtUserName')) document.getElementById('profilePage_txtUserName').onchange = function () { appController.updateName(this); }
        if (document.getElementById('profile_serverUrl')) document.getElementById('profile_serverUrl').onchange = function () { appController.updateServerURL(this); }

        if (document.getElementById('btnJoinRoom')) document.getElementById('btnJoinRoom').onclick = function () { appController.joinRoom(); }

        if (document.getElementById('flagMode')) document.getElementById('flagMode').onclick = function () { appController.flagModeToggle(); }
        if (document.getElementById('leaderboardToggle')) document.getElementById('leaderboardToggle').onclick = function () { appController.leaderboardToggleSize(); }
        if (document.getElementById('leaderboard')) document.getElementById('leaderboard').onclick = function () { appController.leaderboardToggleSize(); }

        if (document.getElementById('howToPlayPopUp')) document.getElementById('howToPlayPopUp').onclick = function () {
            document.getElementById('howToPlayPopUp').style.display = 'none';
        }
        if (document.getElementById('newFlag')) document.getElementById('newFlag').onclick = function () { appController.selectFlag(20); }
        if (document.getElementById('winNewFlag')) document.getElementById('winNewFlag').onclick = function () { appController.winNewFlag(); }

        if (document.getElementById('startClassicGame8')) document.getElementById('startClassicGame8').onclick = function () { appController.startClassicGame(8); }
        if (document.getElementById('startClassicGame16')) document.getElementById('startClassicGame16').onclick = function () { appController.startClassicGame(16); }
        if (document.getElementById('startClassicGame32')) document.getElementById('startClassicGame32').onclick = function () { appController.startClassicGame(32); }
        if (document.getElementById('startClassicGame64')) document.getElementById('startClassicGame64').onclick = function () { appController.startClassicGame(64); }
        if (document.getElementById('startClassicGame128')) document.getElementById('startClassicGame128').onclick = function () { appController.startClassicGame(128); }
        if (document.getElementById('startClassicGame256')) document.getElementById('startClassicGame256').onclick = function () { appController.startClassicGame(256); }

        if (document.getElementById('btnLoginFacebook')) document.getElementById('btnLoginFacebook').onclick = function () { appController.loginFacebook(); }

        if (document.getElementById('serverDropdown')) { document.getElementById('serverDropdown').onchange = function () { appController.updateServerURL(this); } }

        //loop through all flags and add onclick event
        let flagElements = document.querySelectorAll("[data-flagid]");
        for (var i = 0; i < flagElements.length; i++) {
            var flagElement = flagElements[i];
            flagElement.onclick = function () { appController.selectFlag(Number(this.dataset.flagid), Number(this.dataset.cost)); }
        }

        //loop through all avatars and add onclick event
        let avatarElements = document.querySelectorAll("[data-type='avatar']");
        for (let i = 0; i < avatarElements.length; i++) {
            let avatarElement = avatarElements[i];
            avatarElement.onclick = function () { appController.selectAvatar(this.dataset.avatarid); }
        }

        if (document.getElementById('btnShareToCoin')) document.getElementById('btnShareToCoin').onclick = function () { appController.shareOnFacebook(); }
        if (document.getElementById('shareToUnlockFlagsTwitter')) document.getElementById('shareToUnlockFlagsTwitter').onclick = function () { appController.shareToUnlockFlags('twitter'); }
        if (document.getElementById('shareToUnlockFlagsFacebook')) document.getElementById('shareToUnlockFlagsFacebook').onclick = function () { appController.shareToUnlockFlags('facebook'); }

        if (document.getElementById('buySetDungeon')) document.getElementById('buySetDungeon').onclick = function () { appController.buySet('Dungeon'); }
        if (document.getElementById('buySetX')) document.getElementById('buySetX').onclick = function () { appController.buySet('X'); }

        //testers
        if (document.getElementById('testShowNotification')) document.getElementById('testShowNotification').onclick = function () { appController.showNotification('This is a notification'); }


    };
    hashchange(e) {

        //save user data
        Storage.save('user', this.user);

        //Analytics - Page Level
        //this.trackPage("Main");

        var hash = location.hash;
        if (hash === "") {
            this.showPage("menu");
            return;
        }
        if (hash === "#/") {
            this.showPage("menu");
            return;
        }
        if (hash === "#/menu") {
            this.showPage("menu");
            return;
        }
        if (hash === "#/loading") {
            this.showPage("loading");
            return;
        }
        if (hash === "#/room") {
            this.showPage("room");
            return;
        }
        if (hash === "#/game") {
            this.startGame();
            return;
        }
        if (hash.startsWith("#/game/")) {
            const roomId = hash.replace("#/game/", "");
            this.startGame(roomId);
            return;
        }
        if (hash === "#/flags") {
            this.showPage("flags");
            return;
        }
        if (hash.lastIndexOf("#/login", 0) === 0) {
            this.showPage("login");
            return;
        }
        if (hash === "#/howtoplay") {
            this.showPage("howtoplay");
            return;
        }
        if (hash === "#/profile") {
            this.showPage("profile");
            return;
        }
        if (hash === "#/settings") {
            this.showPage("settings");
            return;
        }
        if (hash === "#/winflag") {
            this.showPage("winflag");
            return;
        }
        if (hash === "#/achievements") {
            this.showPage("achievements");
            return;
        }
        if (hash === "#/gameover") {
            this.showPage("gameover");
            return;
        }
        if (hash === "#/levelselect") {
            this.showPage("levelselect");
            return;
        }
        if (hash === "#/about") {
            this.showPage("about");
            return;
        }
        this.showPage("menu");
    };
    onMessage(message, value, player) {
        if (message === "leave") {
            this.showPage("menu");
        }
        if (message === "gameOver") {

            //award exp for points
            //note: model could do this if player and user are sperate
            //note: could be done on server, should be, but what about offline game
            //note: could be done in player class but it is a pure data class
            var localPlayer = this.minesweeper.getPlayer(this.minesweeper.localPlayerId);
            if (localPlayer) {

                this.user.exp += localPlayer.points || 0;
                this.user.mineCount_total += localPlayer.mineCount || 0;
                this.user.flaggedMiss_total += localPlayer.flaggedMiss || 0;
                this.user.triggerMine_total += localPlayer.triggerMineCount || 0;
                this.user.longestStreak = Math.max(localPlayer.longestStreak || 0, this.user.longestStreak || 0);
                this.user.multiplier_max = Math.max(localPlayer.multiplier_max || 0, this.user.multiplier_max || 0);
                if (this.minesweeper.minesLeft === 0) {
                    this.user.gamesPlayed = (this.user.gamesPlayed || 0) + 1;
                }

                //todo: similar to checkForAchievementAndReward (two methods, one includes updating user)
                var oldLevel = this.user.level;
                Level.checkLevel(this.user);

                var achievements = Achievement.checkForAchievementAndReward(this.user);
                //show pop with new achievement is triggered by event

            }
        }
        if (message === "scoreChanged") {
            //get points from local player not, global points
            var localPlayer = this.minesweeper.getPlayer(this.user.id);
            if (localPlayer) {
                var gameMenu_Points = document.getElementById("gameMenu_Points");
                gameMenu_Points.innerHTML = localPlayer.points;
            }
        }
        if (message === "multiplierChanged") {
            //get points from local player not, global points
            var localPlayer = this.minesweeper.getPlayer(this.user.id);
            if (localPlayer) {
                var gameMenu_Multiplier = document.getElementById("gameMenu_Multiplier");
                gameMenu_Multiplier.innerHTML = localPlayer.multiplier;
            }
        }

        if (message === "fullGameState") {
            //get points from local player not, global points
            var localPlayer = this.minesweeper.getPlayer(this.user.id);
            if (localPlayer) {
                var gameMenu_Points = document.getElementById("gameMenu_Points");
                gameMenu_Points.innerHTML = localPlayer.points;
                var gameMenu_Multiplier = document.getElementById("gameMenu_Multiplier");
                gameMenu_Multiplier.innerHTML = localPlayer.multiplier;
            }
        }
        if (message === "gameStats") {
            //get points from local player not, global points
            var localPlayer = this.minesweeper.getPlayer(this.user.id);
            if (localPlayer) {
                var gameMenu_Points = document.getElementById("gameMenu_Points");
                gameMenu_Points.innerHTML = localPlayer.points;
                var gameMenu_Multiplier = document.getElementById("gameMenu_Multiplier");
                gameMenu_Multiplier.innerHTML = localPlayer.multiplier;
            }
        }
        if (message === "playerData" || message === "scoreChanged" || message === "fullGameState" || message === "gameStats" || message === "showLeaderBoard") {
            this.leaderboardUpdate();
        }
        if (message === "leave" || message === "stateChanged") {
            this.leaderboardClear();
        }
        if (message === "stateChanged") {
            if (value === "pregame") {
                //show pre screen
                this.showPage("game");
                console.log("--------pregame--------");
            }
            if (value === "playing") {
                //show end screen 
                this.showPage("game");
                console.log("--------playing--------");

            }
            if (value === "postgame") {
                if (!this.singlePlayerRules) {
                    //show game screen 
                    this.showPage("gameover");

                    //try show ad
                    if (this.adPlayer)
                        this.adPlayer.tryShowAd();
                }
                console.log("--------postgame--------");

            }
        }
        if (message === "restarting") {
            //update count down for next game
            var countDownElement = document.getElementById("countDown");
            if (countDownElement)
                document.getElementById("countDown").innerText = value;
        }
    };
    leaderboardClear() {
        //clear leaderboard 
        var leaderboard = document.getElementById("leaderboardList");
        while (leaderboard.firstChild) {
            leaderboard.removeChild(leaderboard.firstChild);
        }
        this.leaderboardHideShow();
    }
    leaderboardHideShow(show) {
        const isVisible = this.minesweeper.showLeaderboard;

        //hide or show the html version
        var leaderboardElement = document.getElementById("leaderboard");
        if (leaderboardElement) {
            leaderboard.style.display = isVisible ? "block" : "none";
        }
    };
    leaderboardToggleSize() {
        //hide or show the html version
        var leaderboardElement = document.getElementById("leaderboard");
        if (leaderboardElement) {
            //toggle leaderboardSmall class
            leaderboardElement.classList.toggle("leaderboardSmall");
        }
    }
    leaderboardUpdate() {
        this.leaderboardHideShow();

        //get leaderboard data
        var players = this.minesweeper.players.sort(function (a, b) { return b.points - a.points });


        //set leaderboard
        var leaderboard = document.getElementById("leaderboardList");
        if (leaderboard) {
            for (let i = 0; i < players.length; i++) {
                let player = players[i];
                //add player to ol list name "leaderboard" if not already there
                let leaderboardPlayer = leaderboard.querySelector(`[data-playerid="${player.id}"]`);
                if (!leaderboardPlayer) {
                    //create li
                    leaderboardPlayer = document.createElement("div");
                    leaderboardPlayer.className = "leaderboardListItem";
                    leaderboardPlayer.dataset.playerid = player.id;
                    //if self highlight
                    if (player.id === this.user.id) leaderboardPlayer.classList.add("highlighted");
                    leaderboardPlayer.innerHTML += `<div class="leaderboardFlag flag flag_${player.flag}"></div>`;

                    let avatar = player.avatar || "assets/avatars/default-avatar.png";
                    leaderboardPlayer.innerHTML += `<img class="leaderboardAvatar" src="${avatar}"></img>`;

                    leaderboardPlayer.innerHTML += `<span class="leaderboardText">${player.name}</span>`;

                    leaderboard.appendChild(leaderboardPlayer);
                }
                //update order
                let order = i;
                leaderboardPlayer.style.order = order;
                leaderboardPlayer.dataset.order = order;
            }
        }
    }
    refreshPage() {
        this.showPage(this.page);
    }
    showPage(page) {
        this.page = page;
        var wasGameActive = document.documentElement.classList.contains("game-active");
        var isGameActive = page.indexOf("game") > -1;
        document.documentElement.classList.toggle("game-active", isGameActive);
        if (wasGameActive !== isGameActive && this.game && this.game.scale) {
            requestAnimationFrame(() => this.game.scale.refresh());
        }
        //GA Analytics loggin
        this.trackPage(page);
        ////user default GA script, but wont work on mobile
        //if (typeof ga !== 'undefined') {
        //    ga('send', 'pageview', page);
        //}
        document.getElementById("loading").classList.remove("show");
        document.getElementById("menuPage").classList.remove("show");
        document.getElementById("roomPage").classList.remove("show");
        document.getElementById("loginPage").classList.remove("show");
        document.getElementById("flagsPage").classList.remove("show");
        document.getElementById("endGamePage").classList.remove("show");
        document.getElementById("howToPlayPage").classList.remove("show");
        document.getElementById("gamePage").classList.remove("show");
        document.getElementById("profilePage").classList.remove("show");
        document.getElementById("settingsPage").classList.remove("show");
        document.getElementById("winflag").classList.remove("show");
        document.getElementById("achievementsPage").classList.remove("show");
        document.getElementById("levelSelectPage").classList.remove("show");
        document.getElementById("aboutPage").classList.remove("show");

        if (this.game && this.game.isRunning) this.game.paused = true;

        document.getElementById('game').className = "hideGame";

        if (page === "loading") {
            document.getElementById("loading").classList.add("show");
        }
        if (page === "room") {
            document.getElementById("roomPage").classList.add("show");
            if (this.user.roomId) {
                var txtRoomId = document.getElementById("txtRoomId");
                if (txtRoomId) txtRoomId.value = this.user.roomId;
            }
        }
        if (page === "login") {
            document.getElementById("loginPage").classList.add("show");


            //var hash = location.hash;
            //if (hash === "#/login/autologin") {
            //    this.loginFacebook();
            //}

            //get facebook login if any
            var hash = location.hash;
            if (hash.startsWith("#/login/")) {
                var match = hash.match(/#\/login\/(.*)/);
                if (match) {
                    var facebooktoken = match[1];
                    if (facebooktoken !== "autologin") {
                        Facebook.getInfo(facebooktoken, function (data) {

                            this.user.name = data.first_name;
                            this.user.email = data.email;
                            this.user.avatar = "https://graph.facebook.com/" + data.id + "/picture?type=normal";;
                            this.user.facebookid = data.id;
                            this.user.accessToken = data.accessToken;

                            this.showPage("menu");
                        });
                    }
                    if (facebooktoken === "autologin") {
                        this.loginFacebook();
                    }
                }
            }



        }

        if (page === "levelselect") {
            document.getElementById("levelSelectPage").classList.add("show");

        }
        if (page === "menu") {
            this.minesweeper.leave();
            if (this.game) this.game.state.start('MenuUI', true, false);


            location.hash = "#/menu";
            document.getElementById("menuPage").classList.add("show");

            //check for updated level
            Level.checkLevel(this.user);

            //todo: check for achievement not awarded

            //set user name
            var txtUserName = document.getElementById("txtUserName");
            txtUserName.value = this.user.name;


            var user_userName = document.getElementById("user_userName");
            user_userName.innerHTML = this.user.name || "No Name";

            var user_avatar = document.getElementById("user_avatar");
            user_avatar.src = this.user.avatar || "assets/avatars/default-avatar.png";

            var user_gold = document.getElementById("user_gold");
            user_gold.innerHTML = this.user.gold;

            var user_level = document.getElementById("user_level");
            user_level.innerHTML = this.user.level;

            var user_expForLevel = document.getElementById("user_expForLevel");
            user_expForLevel.innerHTML = this.user.expForLevel;

            var user_expToNextlevel = document.getElementById("user_expToNextlevel");
            user_expToNextlevel.innerHTML = this.user.expToNextlevel;

            var user_levelProgress = document.getElementById("user_levelProgress");
            var nextLevelPercentage = (this.user.expForLevel / this.user.expToNextlevel) * 100;
            user_levelProgress.style.width = nextLevelPercentage + "%";




            var achievementsEarned = (this.user.achievements ? this.user.achievements.length : 0);
            var achievementsTotal = (Achievement.allAchievements ? Achievement.allAchievements.length : 1);


            var user_achievementCount = document.getElementById("user_achievementCount");
            user_achievementCount.innerHTML = achievementsEarned;

            var user_achievementTotalCount = document.getElementById("user_achievementTotalCount");
            user_achievementTotalCount.innerHTML = achievementsTotal;

            var user_achievementProgress = document.getElementById("user_achievementProgress");
            var achievementPercentage = (achievementsEarned / achievementsTotal) * 100;
            user_achievementProgress.style.width = achievementPercentage + "%";

            //set flag button image
            var imgSelectedFlag = document.getElementById("imgSelectedFlag");
            imgSelectedFlag.className = "flag flag_" + this.user.flag;

            //private room id
            if (this.user.roomId) {
                var user_roomId = document.getElementById("txtRoomId");
                if (user_roomId) user_roomId.value = this.user.roomId;
            }

            //server URL - populate server dropdown with serverUrls and select this.serverUrl value
            let serverDropdown = document.getElementById("serverDropdown");
            let serverUrls = this.serverUrls;
            let serverUrl = this.serverUrl;

            if (serverDropdown && serverUrls) {
                //clear old list of flags
                while (serverDropdown.firstChild) {
                    serverDropdown.removeChild(serverDropdown.firstChild);
                }
                //generate server url list
                var defaultOption = document.createElement("option");
                defaultOption.value = "";
                defaultOption.innerHTML = "Server";
                serverDropdown.appendChild(defaultOption);
                for (var key in serverUrls) {
                    var serverUrlOpt = document.createElement("option");
                    serverUrlOpt.value = serverUrls[key];
                    serverUrlOpt.innerHTML = key;
                    if (serverUrl === serverUrls[key]) {
                        serverUrlOpt.selected = true;
                    }
                    serverDropdown.appendChild(serverUrlOpt);
                }
            } else {
                serverDropdown.style.display = "none";
            }




        }
        if (page === "achievements") {
            document.getElementById("achievementsPage").classList.add("show");


            var achievementList = document.getElementById("achievementsPage_achievementList");

            //clear old list of flags
            while (achievementList.firstChild) {
                achievementList.removeChild(achievementList.firstChild);
            }
            //generate achievement list
            var achievements = Achievement.allAchievements;
            for (var i = 0; i < achievements.length; i++) {
                var achievement = achievements[i];

                //check if user has achievement
                var hasAchievement = (this.user.achievements.indexOf(achievement.Name) !== -1);

                var achievementElement = document.createElement("li");
                if (!hasAchievement)
                    achievementElement.className = "NotFound";//ng-class="{'NotFound': !achievement.hasAchievement}

                var image = document.createElement("img");
                image.src = 'images/Achievements/' + achievement.Image;

                var points = document.createElement("div");
                points.className = "points";
                points.innerHTML = achievement.Points;

                var title = document.createElement("div");
                title.className = "title";
                title.innerHTML = achievement.Title;

                var description = document.createElement("div");
                description.className = "description";
                description.innerHTML = achievement.Description;


                achievementElement.appendChild(image);
                achievementElement.appendChild(points);
                achievementElement.appendChild(title);
                achievementElement.appendChild(description);
                achievementList.appendChild(achievementElement);
            }

            //<li ng-repeat="achievement in achievements  | orderBy:Order" ng-class="{'NotFound': !achievement.hasAchievement}">
            //    <img src='images/Achievements/{{achievement.hasAchievement ? achievement.Image:"none.png" }}' />
            //    <div class='title'>{{achievement.Title}}</div>
            //    <div class='description'>{{achievement.Description}}</div>
            //</li>
            //{
            //    "Name": "Played First Game",
            //    "Category": "Overall",
            //    "Title": "Let the Games Begin",
            //    "Description": "Played First Game",
            //    "Image": "ace.png",
            //    "Points": "3",
            //    "PushToFacebook": "true",
            //    "Order": "1",
            //}


        }
        if (page === "winflag") {
            document.getElementById("winflag").classList.add("show");
            var divExplode = document.getElementById('divWinflag');
            divExplode.classList.remove('explodeAnimate');
        }

        if (page === "profile") {
            document.getElementById("profilePage").classList.add("show");


            var profilePage_txtUserName = document.getElementById("profilePage_txtUserName");
            profilePage_txtUserName.value = this.user.name;

            var profilePage_txtUserEmail = document.getElementById("profilePage_txtUserEmail");
            profilePage_txtUserEmail.value = this.user.email || null;


            var profile_exp = document.getElementById("profile_exp");
            profile_exp.innerHTML = this.user.exp;

            var profile_mineCount_total = document.getElementById("profile_mineCount_total");
            profile_mineCount_total.innerHTML = this.user.mineCount_total;

            var profile_flaggedMiss_total = document.getElementById("profile_flaggedMiss_total");
            profile_flaggedMiss_total.innerHTML = this.user.flaggedMiss_total;

            var profile_triggerMine_total = document.getElementById("profile_triggerMine_total");
            profile_triggerMine_total.innerHTML = this.user.triggerMine_total;

            var profile_longestStreak = document.getElementById("profile_longestStreak");
            profile_longestStreak.innerHTML = this.user.longestStreak;

            var profile_multiplier_max = document.getElementById("profile_multiplier_max");
            profile_multiplier_max.innerHTML = this.user.multiplier_max;


            var profile_gamesPlayed = document.getElementById("profile_gamesPlayed");
            profile_gamesPlayed.innerHTML = this.user.gamesPlayed;

            //populate avatar image discord
            var profile_avatar_discord = document.getElementById("profile_avatar_discord");
            if (profile_avatar_discord) {
                profile_avatar_discord.src = this.user.avatar_discord || "";
                profile_avatar_discord.dataset.avatarid = this.user.avatar_discord || "";
            }
            //populate avatar current
            var profile_avatar_current = document.getElementById("profile_avatar_current");
            if (profile_avatar_current) {
                profile_avatar_current.src = this.user.avatar || "";
                profile_avatar_current.dataset.avatarid = this.user.avatar || "";
            }



            //highlight selected avatar
            var avatars = document.querySelectorAll("#profilePage .avatar");
            for (var i = 0; i < avatars.length; i++) {
                var avatar = avatars[i];
                if (avatar.dataset.avatarid == this.user.avatar) {
                    avatar.classList.add("selected");
                } else {
                    avatar.classList.remove("selected");
                }
            }


            //server URL
            var profile_serverUrl = document.getElementById("profile_serverUrl");
            profile_serverUrl.value = this.user.serverUrl;

        }
        if (page === "settings") {
            document.getElementById("settingsPage").classList.add("show");

        }
        if (page === "about") {
            document.getElementById("aboutPage").classList.add("show");

        }
        if (page === "flags") {
            document.getElementById("flagsPage").classList.add("show");

            //todo: auto gerneate from config file

            //disable/enable flags owned
            var flags = this.user.flags;
            var flagElements = document.querySelectorAll("#flagsPage .flag");
            for (var i = 0; i < flagElements.length; i++) {
                var flagElement = flagElements[i];

                if (flags.indexOf(Number(flagElement.dataset.flagid)) !== -1)
                    flagElement.classList.remove("disabled");
                else
                    flagElement.classList.add("disabled");
            }


            //var flagList =  document.getElementById("flagList");

            ////clear old list of flags
            //while (flagList.firstChild) {
            //    flagList.removeChild(flagList.firstChild);
            //}
            ////generate flag buttons
            //var flags = this.user.flags;
            //for (var i = 0; i < flags.length; i++) {
            //        var flag = flags[i];
            //        var flagBtn = document.createElement("div");
            //        flagBtn.className = "flag flag_" + flag;
            //        flagBtn.onclick =  this.updateFlag.bind(this, flag);
            //        flagList.appendChild(flagBtn);
            //}

            //todo: check currentFlag
        }
        if (page === "howtoplay") {
            document.getElementById("howToPlayPage").classList.add("show");
        }
        //starts with "game"
        if (page.indexOf("game") > -1) {

            document.getElementById("gamePage").classList.add("show");

            document.getElementById('game').className = "showGame";

            //show how to play popup
            if (!this.user.hasSeenHowToPlay) {
                this.user.hasSeenHowToPlay = true;
                var howToPlayPopUp = document.getElementById('howToPlayPopUp');
                howToPlayPopUp.style.display = 'block';
            }

            if (this.game) this.game.paused = false;
        }


        if (page === "gameover") {
            document.getElementById("endGamePage").classList.add("show");

            //populate personal score

            var localPlayer = this.minesweeper.getPlayer(this.minesweeper.localPlayerId);
            if (localPlayer) {
                //var localPlayerName = document.getElementById("localPlayerName");
                //localPlayerName.innerHTML = localPlayer.name;

                var mineCount = document.getElementById("mineCount");
                mineCount.innerHTML = localPlayer.mineCount;

                var points = document.getElementById("points");
                points.innerHTML = localPlayer.points;

                var flaggedMiss = document.getElementById("flaggedMiss");
                flaggedMiss.innerHTML = localPlayer.flaggedMiss;

                var triggerMineCount = document.getElementById("triggerMineCount");
                triggerMineCount.innerHTML = localPlayer.triggerMineCount;

                var longestStreak = document.getElementById("longestStreak");
                longestStreak.innerHTML = localPlayer.longestStreak;

                //var streakBonus = document.getElementById("streakBonus");
                //streakBonus.innerHTML = localPlayer.streakBonus;
            }



            //populate leaderboard 
            var table = document.getElementById("tblLeaderboard");
            var players = this.minesweeper.players.sort(function (a, b) { return b.points - a.points });
            //clear rows
            var rowCount = table.rows.length;
            for (var i = 1; i < rowCount; i++) {
                table.deleteRow(1);
            }
            for (var i = 0; i < players.length; i++) {
                var player = players[i];
                var row = table.insertRow(-1);
                if (localPlayer && localPlayer.id === player.id) {
                    row.className = "highlighted";
                }
                var cell1 = row.insertCell(0);
                var cell2 = row.insertCell(1);
                var cell3 = row.insertCell(2);

                cell1.innerHTML = i + 1;
                cell2.innerHTML = player.name;
                cell3.innerHTML = player.points;

            }


        }




    }
    checkForFacebookAutoLogin() {
        //get facebook login if any
        var hash = location.hash;
        if (hash.startsWith("#/login/")) {
            var match = hash.match(/#\/login\/(.*)/);
            if (match) {
                var facebooktoken = match[1];
                if (facebooktoken !== "autologin") {
                    Facebook.getInfo(facebooktoken, function (data) {

                        this.user.name = data.first_name;
                        this.user.email = data.email;
                        this.user.avatar = "https://graph.facebook.com/" + data.id + "/picture?type=normal";;
                        this.user.facebookid = data.id;
                        this.user.accessToken = data.accessToken;

                        this.showPage("menu");
                    });
                }
                if (facebooktoken === "autologin") {
                    this.loginFacebook();
                }
            }
        }
    }
    showAchievementPopup(achievements) {
        //if (!achievements) return;

        //reset and play animation
        var achievementPopup = document.getElementById("achievementPopup");
        achievementPopup.classList.remove('showAchievementPopup');
        void achievementPopup.offsetWidth;
        achievementPopup.classList.add("showAchievementPopup");


        var achievementList = document.getElementById("achievementPopup_achievementList");


        if (!achievements) return;
        //clear old list of flags
        while (achievementList.firstChild) {
            achievementList.removeChild(achievementList.firstChild);
        }

        //show pop with new achievement
        for (var i = 0; i < achievements.length; i++) {
            var achievement = achievements[i];
            var achievementElement = document.createElement("li");

            var image = document.createElement("img");
            image.src = 'images/Achievements/' + achievement.Image;

            var title = document.createElement("div");
            title.className = "title";
            title.innerHTML = achievement.Title;

            var description = document.createElement("div");
            description.className = "description";
            description.innerHTML = achievement.Description;


            achievementElement.appendChild(image);
            achievementElement.appendChild(title);
            achievementElement.appendChild(description);
            achievementList.appendChild(achievementElement);
        }

    }
    showNotification(message, duration, playSound = true) {
        //if string then create element
        if (typeof message == "string") {
            let element = document.createElement("div");
            element.innerText = message;
            element.classList.add("notificationItem");
            this.showNotificationElement(element, duration, playSound);
        }
    }
    showNotificationElement(content, duration, playSound = true) {
        if (!duration) duration = 5;

        let notifications = document.getElementById("notifications");
        if (!notifications) return;

        //play sound
        if (this.playSound)
            this.playSound("PointSound");

        //create notification container
        let notification = document.createElement("div");
        notification.classList.add("notification");
        notification.style.animationDuration = duration + "s";
        notification.onclick = function () {
            this.style.display = "none";
        };
        notification.appendChild(content);

        //auto hide timer
        window.setTimeout(function () {
            notifications.removeChild(notification);
        }, duration * 1000);

        //add to list
        notifications.appendChild(notification);

    }
    createGameUI() {
        //create game UI - once

        //todo: convert back to WEBGL when phaser 2.7 is out. 
        //var renderMethod = Phaser.AUTO;
        var renderMethod = Phaser.CANVAS;

        var isWindowsPhone = navigator.userAgent.match(/iemobile/i);
        if (isWindowsPhone) renderMethod = Phaser.CANVAS;
        if (localStorage.renderMethod === 'canvas') renderMethod = Phaser.CANVAS;
        if (localStorage.renderMethod === 'auto') renderMethod = Phaser.AUTO;
        if (localStorage.renderMethod === 'webgl') renderMethod = Phaser.WEBGL;


        //todo: convert back to WEBGL when phaser 2.7 is out.  the WEBGL tilemap is optimzed in that version.
        //https://phaser.io/news/2016/07/webgl-tilemap-renderer
        //webgl breaks BLU phone on chrome


        //new Game(width, height, renderer, parent, state, transparent, antialias, physicsConfig)
        this.game = new Phaser.Game('100%', '100%', renderMethod, 'game', null, false, true);
        this.game.state.add('MenuUI', MenuUI);
        //this.game.state.add('LevelSelectUI', LevelSelectUI);
        //this.game.state.add('HowToPlayUI', HowToPlayUI);
        this.game.state.add('MinesweeperUI', MinesweeperUI);
        this.game.state.start('MenuUI');

    }
    leaveGame() {
        //show game page
        this.showPage("menu");
        this.minesweeper.leave();
    };
    updateName(sender) {
        if (sender) {
            this.user.name = sender.value;
        }
    }
    updateServerURL(sender) {
        if (sender) {
            this.serverUrl = sender.value;
            this.user.serverUrl = sender.value;
        }
    }
    startClassicGame(size) {
        if (!size) size = 64;

        //get user profile
        var user = this.user;

        //update user name
        var txtUserName = document.getElementById("txtUserName").value;
        if (txtUserName) user.name = txtUserName;


        //destroy any old game
        this.minesweeper.destroy();


        this.minesweeper = new Minesweeper("Classic64x64", size, size, size * size / 6);
        this.minesweeper.init();
        this.minesweeper.showLeaderboard = false;
        this.minesweeper.singlePlayerRules = true;

        //listen to game events
        this.minesweeper.onMessage2 = this.onMessage.bind(this);
        var localPlayer = new PlayerLocal(user.id, user.name, user.flag)
        this.minesweeper.join(localPlayer);
        this.minesweeper.localPlayerId = localPlayer.id;

        //clear old game
        // this.game.state.remove("MinesweeperUI");
        // this.game.state.add('MinesweeperUI', MinesweeperUI);
        this.game.state.start('MinesweeperUI', true, true, this.minesweeper, localPlayer);


        //show game page
        this.showPage("game/classic/" + size);
    };


    playGoogleAd() {
        //var googleTagAd = 'https://pubads.g.doubleclick.net/gampad/ads?sz=640x480&iu=/124319096/external/single_ad_samples&ciu_szs=300x250&impl=s&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator=';
        //// var googleTagAd = 'http://googleads.g.doubleclick.net/pagead/ads?ad_type=video&client=ca-games-pub-4968145218643279&videoad_start_delay=0&description_url=http%3A%2F%2Fminesweeper.io&max_ad_duration=40000&adtest=on&cust_params=deployment%3Ddevsite%26sample_ct%3Dskippablelinear&correlator=';
        //var ima3 = new Ima3("adContainer", googleTagAd);
        //ima3.showAd();
    };
    joinRoom() {
        let roomId = null;
        const txtRoom = document.getElementById("txtRoomId");
        if (txtRoom) roomId = txtRoom.value || null;
        if (!roomId) { this.showNotification("Please enter a room id"); return; }

        this.startGame(roomId);
    }
    startGame(roomId) {
        if (this.adPlayer)
            this.adPlayer.tryShowAd();

        let size = 64; //not used for online

        //get user profile
        var user = this.user;

        //update user name
        var txtUserName = document.getElementById("txtUserName").value;
        if (txtUserName) user.name = txtUserName;


        //destroy any old game
        this.minesweeper.destroy();


        //get server
        // var serverUrl = 'https://minesweeper.jdsoftwarellc.com';
        //var serverUrl = 'ws://localhost:8005';
        var serverUrl = this.serverUrl || Config.serverUrl_Default;
        var ddlServerUrl = document.getElementById("ddlServerUrl");
        if (ddlServerUrl) {
            var ddlServerUrlSelectedValue = ddlServerUrl.options[ddlServerUrl.selectedIndex].value;
            if (ddlServerUrlSelectedValue) serverUrl = ddlServerUrlSelectedValue;
        }

        //todo: may need to wait until socket connected to "join" game online
        this.minesweeper = new MinesweeperProxy("Online", size, size, size * size / 6, serverUrl);
        this.minesweeper.showLeaderboard = true;
        this.minesweeper.singlePlayerRules = false;
        this.minesweeper.init().then(() => {
            //listen to game events
            this.minesweeper.onMessage2 = this.onMessage.bind(this);
            var localPlayer = new PlayerLocal(user.id, user.name, user.flag, user.avatar);
            this.minesweeper.join(localPlayer, roomId);
            this.minesweeper.localPlayerId = localPlayer.id;

            //clear old game
            //this.game.state.remove("MinesweeperUI");
            //this.game.state.add('MinesweeperUI', MinesweeperUI);

            //MinesweeperUI is the local player and localPlayer is just an empty place holder
            this.game.state.start('MinesweeperUI', true, true, this.minesweeper, localPlayer);

            //show game page
            this.showPage("game");
        }).catch((err) => {
            this.showNotification("Error connecting to server");
            // error here
            console.error(err);
        });



    };
    buySet(setName) {
        this.showNotification("Purchasing sets are disabled at this time");
    }
    shareToUnlockFlags(method) {

        if (method === 'twitter')
            this.shareOnTwitter();
        else
            this.shareOnFacebook();

        for (var i = 64; i < 80; i++) {
            this.user.flags.push(i);
        }

        this.showPage("menu");
    };
    selectAvatar(avatar) {
        this.user.avatar = avatar;
        this.showNotification(`Avatar updated`);
        this.showPage("menu");
    }
    selectFlag(flag, cost) {

        //check if flag is locked
        var flags = this.user.flags;
        if (flags.indexOf(flag) === -1) {
            if (!cost) {
                this.showNotification("This flag is locked");
                return;
            }
            if (this.user.gold < cost) {
                this.showNotification("You do not have enough coins.");
                return;
            }
            //var results = confirm("Would you like to buy the flag for " + cost + " coins?");
            //if (results) {
            this.user.gold -= cost;
            this.user.flags.push(flag);
            this.user.flag = flag;
            this.showPage("flags");
            this.showNotification(`You bought the flag: ${flag}`);
            //}
        } else {
            //update flag
            this.user.flag = flag;
            this.showPage("menu");
        }
    };
    winNewFlag() {
        if (!this.user.gold) this.user.gold = 0;
        if (this.user.gold < 100) {
            this.showNotification("You do not have enough coins.");
            return;
        }
        this.user.gold -= 100;

        //get new flag
        var flagStart = MineCell.FLAG;
        var flagEnd = 65;
        var randomFlag = flagStart + Math.floor(Math.random() * (flagEnd - flagStart));
        this.user.flags.push(randomFlag);

        //populate new flag
        var newFlag = document.getElementById('newFlag');
        newFlag.className = "flag flag_" + randomFlag;
        newFlag.onclick = this.selectFlag.bind(this, randomFlag);


        var divExplode = document.getElementById('divWinflag');
        divExplode.classList.add('explodeAnimate');

        //this.showNotification("Purchasing sets are disabled at this time");
    }
    flagModeToggle() {
        //toggle it
        this.flagMode = !this.flagMode;

        var flagModeElement = document.getElementById('flagMode');
        if (this.flagMode)
            flagModeElement.classList.add('flagButtonPressed');
        if (!this.flagMode)
            flagModeElement.classList.remove('flagButtonPressed');

        if (this.minesweeper) {
            this.minesweeper.flagMode = this.flagMode;
        }
    };

    earnCoins() {
        if (!this.user.gold) this.user.gold = 0;
        this.user.gold += 75;
        this.showPage("menu");
    }
    shareOnFacebook() {

        if (typeof FBInstantGame !== "undefined") {
            FBInstantGame.shareFBInstant();
            return;
        }
        // this.user.gold = (this.user.gold || 0) + 100;

        this.user.hasShared = true;
        Achievement.rewardAchievement(this.user, "Share On Facebook");

        this.showPage("menu");

        //todo: give gold after page is closed



        ////window.open('https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fminesweeper.io&display=popup&ref=plugin&src=share_button', '_system');
        // //this is waht agr.io does 
        // //https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.facebook.com%2Fplayagar.io&display=popup&ref=plugin&src=like&app_id=677505792353827

        // window.open('https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fminesweeper.io&display=popup&ref=plugin&src=share_button', '_system', "height=550,width=525,left=100,top=100,menubar=0");

        //share facebook page not raw url
        // window.open('https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.facebook.com%2Fminesweeper.io&display=popup&ref=plugin&src=share_button', '_system', "height=550,width=525,left=100,top=100,menubar=0");

        window.open('https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fminesweeper.io&display=popup&ref=plugin&src=share_button', '_system', 'height=550,width=525,left=100,top=100,menubar=0');


    };
    shareOnTwitter() {

        // this.user.gold = (this.user.gold || 0) + 100;

        this.user.hasShared = true;
        Achievement.rewardAchievement(this.user, "Share On Twitter");

        this.showPage("menu");

        //share twitter 
        //window.open('https://twitter.com/share?url=http%3A%2F%2Fminesweeper.io&related=&hashtags=minesweeper%2Ciogames&text=http%3A%2F%2Fminesweeper.io%20-%20Multiplayer%20Minesweeper%0Apic.twitter.com/DJxIKHLu3V%0A', '_blank');
        // window.open('https://twitter.com/share?url=http%3A%2F%2Fminesweeper.io&related=&hashtags=minesweeper%2Ciogames&text=minesweeper.io%20-%20Multiplayer%20Minesweeper%0Apic.twitter.com/DJxIKHLu3V%0A', '_blank');
        window.open('https://twitter.com/share?url=http%3A%2F%2Fminesweeper.io&related=&hashtags=minesweeper%2Ciogames&text=minesweeper.io%20-%20Multiplayer%20Minesweeper', '_blank');
    };
    loginFacebook() {
        Facebook.loginFacebook(function (data) {
            this.user.name = data.first_name;
            this.user.email = data.email;
            this.user.avatar = "https://graph.facebook.com/" + data.id + "/picture?type=normal";;
            this.user.facebookid = data.id;
            this.user.accessToken = data.accessToken;
            window.location.href = "#/";
        });
    }

    openMoreGame(url, gameName) {
        this.trackEvent("MoreGameIcons", gameName);

        url = encodeURI(url);
        window.open(url, "_system", 'location=yes');
    }
    openMoreGameFB(gameName) {
        this.trackPage("MoreGames/" + gameName);
        if (typeof FBInstant == "undefinded") return;
        var appId = '1264960130273679';

        if (gameName == "Cribbage") appId = '1264960130273679';
        if (gameName == "Speed") appId = '231387497434707';
        if (gameName == "Nertz") appId = '1303161326511443';
        if (gameName == "Solitaire") appId = '1379968288847447';

        FBInstant.switchGameAsync(appId).catch(function (e) {
            // Handle game change failure
            console.log("FBInstant.switchGameAsync: Error: " + JSON.stringify(e));
        });
    }
    trackPage(page) {
    };
    trackEvent(category, action, label) {
    };
};



var appController = null;
window.addEventListener("DOMContentLoaded", function () {



    ////mobile may need to track with another GA id, an app one not web
    ////todo: if i change it to use the offline GA, then online will get new ids and messup stats.
    ////could do both 
    ////or if it find one online use it else gereate one. Also test if referrals work
    //AnalyticsGA.TrackStart("Minesweeper.io", "1.0.1", "UA-43146845-17");
    //this.trackPage("main");

    appController = new App();
    appController.init();




}, false);
window.onbeforeunload = function (event) {
    // do stuff here

    //return "you have unsaved changes. Are you sure you want to navigate away?";
};
document.addEventListener("deviceready", function () {

    console.log("------deviceready--------");
    if (typeof navigator.splashscreen !== 'undefined')
        navigator.splashscreen.hide();
    if (typeof StatusBar !== 'undefined')
        StatusBar.hide();
    if (typeof cordova !== 'undefined' && typeof cordova.InAppBrowser !== 'undefined') {
        window.open = cordova.InAppBrowser.open;
    }

}, false);


